module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "count-wrap bluestyle"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("碳水化合物")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("克")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-wrap text-center"
  }, [_c('div', {
    staticClass: "result-thumb"
  }, [_c('img', {
    attrs: {
      "src": _vm.cover
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_vm._v("需补打胰岛素")]), _vm._v(" "), _c('div', {
    staticClass: "result-time wcar"
  }, [(_vm.unit) ? _c('div', {
    staticClass: "times"
  }, [_c('span', [_vm._v(_vm._s(_vm.unit))]), _vm._v("单位")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8caf9c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/carbohydrate/carboresult.vue
// module id = 154
// module chunks = 1